export default __webpack_public_path__ + "static/media/banner_1.92b6f6c3.png";